/**
 * The models define the schemas and validation methods for all of the different types of objects.
 *
 * Importantly, the type of each top-level model object is as follows:
 * {
 *     COLLECTION: the name of the firebase collection where this object type is stored
 *     SCHEMA: The yup schema that is used to validate objects of this type
 *     validate: An async validation method for objects of this type
 * }
 *
 * Thus, if a new top-level type is defined, should add a new folder that exports the COLLECTION, SCHEMA and validate
 * fields, and then add it here.
 */
const attribute = require('./attribute');

const location = require('./location');

const organization = require('./organization');

const purchasable = require('./purchasable');

const purchase = require('./purchase');

const activePurchasable = require('./activePurchasable');

const blacklist = require('./blacklist');

const whitelist = require('./whitelist');

const user = require('./user');

const discountCode = require('./discountCode');

module.exports = {
  activePurchasable,
  location,
  organization,
  purchasable,
  purchase,
  attribute,
  blacklist,
  whitelist,
  firestoreModels: [user, location, purchase, purchasable, discountCode]
};